import { forwardRef } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

import { Button } from '@bonusly/ds-button';

import { useMonthPickerContext } from '../month-picker-context';

type MonthRangeOptionProps = PropsWithChildren & {
	startMonth: Date;
	endMonth: Date;
};

export const MonthRangeOption = forwardRef<MonthRangeOptionProps, 'button'>(({ startMonth, endMonth, ...rest }, ref) => {
	const { setRange } = useMonthPickerContext();

	if (!setRange) {
		throw new TypeError('MonthRangeOption must be a child of MonthRangeSelector');
	}

	return (
		<Button colorScheme="secondary" variant="ghost" onClick={() => setRange([startMonth, endMonth])} ref={ref} w="full" justifyContent="flex-start" {...rest} />
	);
});

MonthRangeOption.displayName = 'MonthRangeOption';
